export default __webpack_public_path__ + "static/media/NeoNX110_LateralDer.c79cc42d.webp";